"use strict";

import "./Dialog.css";
import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";

import Popup from "./../Popup";

const ANIMATION_DURATION = 200; // ms

export default class Dialog extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			shown: this.props.shown
		};
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.shown != this.props.shown) {
			this.setState({
				shown: nextProps.shown
			});
		}
	}
	
	render() {
		return (
			<Popup shown={this.state.shown} className="Overlay DialogOverlay">
				<div className={classnames(this.props.className, "Dialog")}>
					{this.props.children}
				</div>
			</Popup>
		);
	}
	
	static createContainer() {
		const container = document.createElement("div");
		container.id = "dialogContainer";
		document.body.appendChild(container);
		return container;
	}
	
	// HAX VESZÉLY :((((((((((((((((((
	
	static open(type, props) {
		
		let dialog;
		
		const update = callback => {
			dialog = ReactDOM.render(React.createElement(type, props), container, callback);
			
			dialog.close = () => {
				props.shown = false;
				update(() => {
					setTimeout(() => {
						ReactDOM.unmountComponentAtNode(container);
						document.body.removeChild(container);
					}, ANIMATION_DURATION);
				});
			}
			return dialog;
		};
		
		const container = this.createContainer();
		props.shown = false;
		
		return update(() => {
			setTimeout(() => {
				props.shown = true;
				update();
			});
		});
	}
}

Dialog.propTypes = {
	shown: React.PropTypes.bool
};

Dialog.defaultProps = {
	shown: false
};


// WEBPACK FOOTER //
// ./~/vwa/components/Dialog/Dialog.jsx